import http from '@/communication/AuthConnection'

export default (params) => {
  return http.post('/v1/stock/set-codes-to-product', params)
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/stock/SetCodesToProduct.js